import { useI18n } from '../locales/I18n';
import { useLayoutEffect, useRef } from 'react';
import type { ReactNode } from 'react';
export function ReaderCarousel({ index, children }: {
    index: number;
    children: ReactNode;
}) {
    const { t, language } = useI18n();
    const viewport = useRef<HTMLDivElement>(null);
    const current = useRef<HTMLDivElement>(null);
    const previous = useRef<{
        index: number;
        content: HTMLElement;
    } | null>(null);
    useLayoutEffect(() => {
        const card = current.current!;
        const old = previous.current;
        previous.current = { index, content: card.cloneNode(true) as HTMLElement };
        if (!old || old.index === index || matchMedia('(prefers-reduced-motion: reduce)').matches)
            return;
        const direction = (index > old.index ? 1 : -1)*(language==='ar'?-1:1);
        const outgoing = old.content;
        outgoing.className = 'carousel-outgoing';
        outgoing.setAttribute('aria-hidden', 'true');
        outgoing.inert = true;
        outgoing.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        viewport.current!.appendChild(outgoing);
        const timing = { duration: 440, easing: 'cubic-bezier(.22,.75,.18,1)', fill: 'both' as const };
        const leave = outgoing.animate([
            { transform: 'translateX(0) scale(1)', opacity: 1 },
            { transform: `translateX(${-direction * 104}%) scale(.96)`, opacity: .1 },
        ], timing);
        const enter = card.animate([
            { transform: `translateX(${direction * 104}%) scale(.96)`, opacity: .35 },
            { transform: 'translateX(0) scale(1)', opacity: 1 },
        ], timing);
        leave.onfinish = () => outgoing.remove();
        enter.onfinish = () => enter.cancel();
        return () => { leave.cancel(); enter.cancel(); outgoing.remove(); };
    }, [index, language]);
    return <div className="story-carousel" aria-roledescription={t("carousel")} aria-label={t("Story slides")}>
    <div className="carousel-viewport" ref={viewport}>
      <div className="carousel-current" ref={current}>{children}</div>
    </div>
  </div>;
}
